import components from './components.json' with { type: 'json' };

export default {
  components,
};
